import { HIERARCHY_LABELS } from '../utils/hierarchyLabels';

export const levelMap = {
  factories: 'factory',
  workshops: 'workshop',
  sections: 'section',
  rooms: 'room',
  cameras: 'camera',
};

// ТЗ №1 §3.3: винительный падеж для «Создать …» — из общей таблицы подписей.
export const levelLabels = {
  factories: HIERARCHY_LABELS.factory.accusative,
  workshops: HIERARCHY_LABELS.workshop.accusative,
  sections: HIERARCHY_LABELS.section.accusative,
  rooms: HIERARCHY_LABELS.room.accusative,
  cameras: HIERARCHY_LABELS.camera.accusative,
};

export const ZONE_COLORS = [
  { stroke: 'rgba(255, 60, 60, 0.9)', fill: 'rgba(255,60,60,0.12)', point: '#ff3c3c' },
  { stroke: 'rgba(30, 120, 255, 0.9)', fill: 'rgba(30,120,255,0.12)', point: '#1e78ff' },
  { stroke: 'rgba(40, 190, 80, 0.9)', fill: 'rgba(40,190,80,0.12)', point: '#28be50' },
  { stroke: 'rgba(220, 80, 220, 0.9)', fill: 'rgba(220,80,220,0.12)', point: '#dc50dc' },
  { stroke: 'rgba(255, 160, 0, 0.9)', fill: 'rgba(255,160,0,0.12)', point: '#ffa000' },
  { stroke: 'rgba(0, 170, 170, 0.9)', fill: 'rgba(0,170,170,0.12)', point: '#00aaaa' },
  { stroke: 'rgba(130, 80, 220, 0.9)', fill: 'rgba(130,80,220,0.12)', point: '#8250dc' },
  { stroke: 'rgba(150, 100, 40, 0.9)', fill: 'rgba(150,100,40,0.12)', point: '#966428' },
  { stroke: 'rgba(140, 200, 0, 0.9)', fill: 'rgba(140,200,0,0.12)', point: '#8cc800' },
  { stroke: 'rgba(255, 90, 160, 0.9)', fill: 'rgba(255,90,160,0.12)', point: '#ff5aa0' },
];

export const EQUIPMENT_CONFIG = {
  monitoring_zone: [[[0, 0], [0, -1], [-1, -1], [-1, 0], [0, 0]]],
  lights_types: ["Поломка", "Плановая остановка", "Работает", "Нет заказа", "ГСО"],
  threshold_light: 220,
  threshold_frame: 30,
  signal_method: "avg",
  scale_factor: 0.5,
};

export const PEOPLE_CONFIG = {
  scale_factor: 0.5,
  monitoring_zone: [[[0, 0], [0, -1], [-1, -1], [-1, 0], [0, 0]]],
  staff_type: [
    {
      title: "Person",
      min_hsv: [0, 0, 0],
      max_hsv: [180, 255, 255],
      bbox_percent: 0.15,
    },
  ],
};

export const PPE_CONFIG = {
  scale_factor: 0.5,
  monitoring_zone: [[[0, 0], [0, -1], [-1, -1], [-1, 0], [0, 0]]],
  gloves_detector: true,
  masks_detector: true,
  hats_detector: true,
};

export const PEOPLE_CAMERA_TYPES = ['PEOPLE', 'PPE'];

export const isPeopleLikeCameraType = (type) => PEOPLE_CAMERA_TYPES.includes(type);

export const getDefaultConfigByCameraType = (cameraType) => {
  if (cameraType === 'EQUIPMENT') return EQUIPMENT_CONFIG;
  if (cameraType === 'PEOPLE') return PEOPLE_CONFIG;
  return PPE_CONFIG;
};

export const getStatusColor = (status) => {
  if (!status) return 'secondary';

  switch (status.toUpperCase()) {
    case 'NEW':
      return 'secondary';
    case 'STARTING':
      return 'info';
    case 'RUNNING':
      return 'success';
    case 'STOPPING':
      return 'warning';
    case 'STOPPED':
      return 'danger';
    case 'RESTARTING':
      return 'warning';
    case 'ERROR':
      return 'danger';
    case 'PENDING_DELETE':
      return 'warning';
    case 'DELETED':
      return 'light';
    default:
      return 'secondary';
  }
};

export const getStatusText = (status) => {
  if (!status) return 'Неизвестно';

  switch (status.toUpperCase()) {
    case 'NEW':
      return 'Новая';
    case 'STARTING':
      return 'Запускается';
    case 'RUNNING':
      return 'Запущена';
    case 'STOPPING':
      return 'Останавливается';
    case 'STOPPED':
      return 'Остановлена';
    case 'RESTARTING':
      return 'Перезапускается';
    case 'ERROR':
      return 'Ошибка';
    case 'PENDING_DELETE':
      return 'На удалении';
    case 'DELETED':
      return 'Удалена';
    default:
      return status;
  }
};
